export default "__VITE_ASSET__ctmnpgzi__"